"use client"

import { colors, sizes } from "@/ui/theme/theme"
import styled from "@emotion/styled"
import { Typography } from "@mui/material"

interface BulletListProps {
  className?: string
  iconRoute?: string
  textColor?: string
  dangerouslySetInnerHTML?: {
    __html: string
  }
}

const StyledBulletList = styled(Typography, {
  shouldForwardProp: (prop) =>
    !["iconRoute", "textColor"].includes(prop as string),
})<{
  iconRoute?: string
  textColor?: string
  iconColor?: string
  useMask?: boolean
  component?: string
}>`
  display: flex;
  flex-direction: column;
  ul {
    display: flex;
    flex-direction: column;
    padding: 0;
    gap: 8px;
    list-style-type: none;
    li {
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      color: ${(props) => props.textColor || colors.black};
      &::before {
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        height: 100%;
        content: "";
        margin-right: ${sizes.baseSingle};
        width: 22px;
        height: 22px;
        background-image: ${(props) =>
          `url(${props.iconRoute || "/icons/check.svg"})`};
      }
    }
  }
`

const BulletList = ({
  className,
  iconRoute = "/icons/check.svg",
  textColor = colors.black,
  dangerouslySetInnerHTML,
}: BulletListProps) => {
  return (
    <StyledBulletList
      className={className}
      iconRoute={iconRoute}
      textColor={textColor}
      dangerouslySetInnerHTML={dangerouslySetInnerHTML}
      component="div"
    />
  )
}

export default BulletList
